(function () {
    'use strict';

    angular
        .module('app')
        .directive('inputEdit', inputEdit);

    inputEdit.$inject = ['$timeout'];

    function inputEdit($timeout) {
        // Usage:
        //     <inputEdit></inputEdit>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                editEnabled: "="
            }
        };
        return directive;

        function link(scope, element, attrs) {
            element[0].focus();
            var val = element[0].value; //store the value of the element
            element[0].value = ''; //clear the value of the element
            element[0].value = val; //set that value back. 
            scope.$watch(function () {
                return scope.editEnabled;
            }, function (value) {
                if (value) {
                    element[0].focus();
                    var val = element[0].value; //store the value of the element
                    element[0].value = ''; //clear the value of the element
                    element[0].value = val; //set that value back. 
                }
            });
        }
    }

})();

jQuery.fn.putCursorAtEnd = function () {

    return this.each(function () {

        // Cache references
        var $el = $(this),
            el = this;

        // Only focus if input isn't already
        if (!$el.is(":focus")) {
            $el.focus();
        }

        // If this function exists... (IE 9+)
        if (el.setSelectionRange) {

            // Double the length because Opera is inconsistent about whether a carriage return is one character or two.
            var len = $el.val().length * 2;

            // Timeout seems to be required for Blink
            setTimeout(function () {
                el.setSelectionRange(len, len);
            }, 1);

        } else {

            // As a fallback, replace the contents with itself
            // Doesn't work in Chrome, but Chrome supports setSelectionRange
            $el.val($el.val());

        }

        // Scroll to the bottom, in case we're in a tall textarea
        // (Necessary for Firefox and Chrome)
        this.scrollTop = 999999;

    });

};